(function() {

  zfrespond.views.EditTextResponseView = Backbone.View.extend({

    events: {
      "click .action-submit": "handleSubmitText"
    },

    template: ZFRESPOND_JST['respond.edit_text_response'],

    className: "edit-text-response-view",

    initialize: function() {
      // this.model.trigger('edit:start', this);
    },

    render: function() {
      this.$el.html(this.template({
        text_response: this.model.get('text_response') || ''
      }));
      return this;
    },

    focus: function() {
      // noop
    },

    remove: function() {
      this.model.trigger('edit:end', this);
      zfrespond.views.EditTextResponseView.__super__.remove.call(this);
    },

    save: function() {
      // media_collector_id needs to be passed in also
      var newText = this.$('textarea.action-edit-text').val();
      this.model.save({
        media_collector_id: this.model.get('media_collector_id'),
        text_response: newText
      }, { patch:true });      
    },

    handleSubmitText: function() {
      if (!this.$('textarea.action-edit-text').val()) {
        return;
      }
      this.save();
      this.trigger('submit', this.model);
    }

  });



  zfrespond.views.EditTextResponseFullpageView = zfrespond.views.EditTextResponseView.extend({

    events: {
      "click .action-submit": "handleSubmitText",
      "click .action-go-back": "handleGoBack",

      'focus textarea': 'handleStopFocusDefault'
    },

    className: "edit-text-response-view edit-text-response-fullpage-view",

    template: ZFRESPOND_JST['respond.edit_text_response_fullpage'],

    handleStopFocusDefault: function(e) {
      _.defer(function() {
        $('body, html').animate({ scrollTop:0 });

      });
    },

    handleGoBack: function() {
      this.trigger('exit');
    },

    handleSubmitText: function() {
      if (!this.$('textarea.action-edit-text').val()) {
        return;
      }
      this.save();
      this.trigger('submit', this.model);
      this.trigger('exit');
    }

  });


}());